'use client';

import { useTranslation } from 'next-i18next';
import { useViewport } from '@/hooks';
import { OptionHorizontalIcon } from '@/icons';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/ui';
import { Button, Drawer, DrawerContent, DrawerTitle, DrawerTrigger, IconButton } from '@/ui_v3';
import { useConfirmPersistData, usePersistButtonVisible } from '../hook/useConfirmPersistData';

/**
 * 임시 저장 불러오기 — 제목·카테고리·문항 목록 전체를 바꾼다.
 * `disabled` 면 누를 수 없다(AI 생성 중 — 생성 결과가 다른 퀴즈 내용에 섞이지 않게).
 */
export const ContinueOnPersistBuildButton = ({
  disabled = false
}: {
  disabled?: boolean;
}) => {
  const {
    handleConfirmPersistData,
    persistData
  } = useConfirmPersistData();
  const isPersistButtonVisible = usePersistButtonVisible();
  const {
    t
  } = useTranslation(['build']);
  const {
    isTablet,
    isMobile
  } = useViewport();
  if (!isPersistButtonVisible) return <></>;
  if (isTablet) return <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <IconButton variant={'outlined'} intent={'neutral'} size="md" disabled={disabled}>
            <OptionHorizontalIcon size="md" />
          </IconButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem className="w-[180px] text-body-sm-medium" onClick={() => handleConfirmPersistData(persistData)}>
            {t('build:continueWriting')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>;
  if (isMobile) return <Drawer>
        <DrawerTrigger asChild>
          <IconButton variant={'outlined'} intent={'neutral'} size="md" disabled={disabled}>
            <OptionHorizontalIcon size="md" />
          </IconButton>
        </DrawerTrigger>
        <DrawerContent className="w-full" hasDrawerHandle hasDim>
          <DrawerTitle className="sr-only">
            {t('build:continueWriting')}
          </DrawerTitle>
          <div className="p-md pb-lg text-body-lg-medium" onClick={() => handleConfirmPersistData(persistData)}>
            {t('build:continueWriting')}
          </div>
        </DrawerContent>
      </Drawer>;
  return <Button size={'md'} variant={'outlined'} intent={'neutral'} disabled={disabled} onClick={() => handleConfirmPersistData(persistData)} data-sentry-element="Button" data-sentry-component="ContinueOnPersistBuildButton" data-sentry-source-file="ContinueOnPersistBuildButton.tsx">
      {t('build.autoSave.writeNext')}
    </Button>;
};